@if (arrData | async; as item) {
  <section class="arr_Outer_Container">
    <div [innerHTML]="item.LargeText2" class="reserve_TextHeading"></div>
    <p [innerHTML]="item.headline" class="terms_Healine"></p>
    <p [innerHTML]="item.h2content" class="terms_SubText"></p>
    <div class="pdf-container">
      <div class="terms_Conditions_Iframe" #termsIframe>
        <iframe class="pdf desktoppdf hidden-xs hidden-sm" [src]="pdfUrl" width="100%" frameborder="0"
        scrolling="no"></iframe>
        <div class="terms-checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="termsAccepted" (change)="onTermsChange()"
              class="rollover_Checkbox" #termsCheckbox />
              <span class="checkbox-button__control"></span>
            </label>
            <div class="terms_And_Conditions">
              <div [innerHTML]="item.text1" class="terms_Conditions_Text"></div>
              <a [href]="pdfUrl" target="_blank" class="terms_link">{{item.text3}}</a>
            </div>
          </div>
        </div>
      </div>
      @if (showError) {
        <p [innerHTML]="item.headline" class="error_Msg"></p>
      }
      <div class="btn_Container">
        <div class="cancel_Btn" [routerLink]="'/my-profile'">
          <img src="../assets/images/arrow-left.svg">
          <span>{{"autorollover.cancelLabel" | cxTranslate}}</span>
        </div>
        <button class="rollover_Btn" (click)="onRolloverClick()">{{item.text2}}</button>
      </div>
    </section>
  }